import React from 'react'
import CareerBody from '../components/career/CareerBody'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'

const Career = () => {
  return (
    <div>
      <Navbar></Navbar>
      <CareerBody></CareerBody>
      <Footer></Footer>
    </div>
  )
}

export default Career
